import React from "react";
import { Col, Flex, Image, Tag, Tooltip, Typography } from "antd";

export default function Tarot({
  id,
  rating,
  image,
  onSelect,
  active,
  title,
  meaning,
}) {
  return (
    <Col
      key={`tarot-${id}`}
      style={{
        borderWidth: 3,
        borderStyle: "solid",
        borderColor: active ? "#1890ff" : "transparent",
        position: "relative",
      }}
      span={4}
      onClick={() => onSelect(id)}
    >
      <Tooltip title={meaning} overlay={null}>
        <Flex vertical>
          {rating && (
            <Tag
              color={rating == "positive" ? "#0b0" : "#f33"}
              style={{ position: "absolute", top: 0, right: 0, zIndex: 2 }}
            >
              {rating == "positive" ? "good" : "bad"}
            </Tag>
          )}
          <Image src={image} preview={false} />
          <Typography.Text>{title}</Typography.Text>
        </Flex>
      </Tooltip>
    </Col>
  );
}
